import Vue from 'vue';

export const InputType = {
  text: 'text',
  number: 'number', // eslint-disable-line id-blacklist
  integer: 'integer',
};

export default Vue.extend({
  name: 'InputableTextBaseMixin',

  props: {
    type: {
      type: String,
      default: InputType.text,
      validator: (v) => Object.values(InputType).includes(v),
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 単位切り替え用
    unit: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    addClass: {
      type: String,
      required: false,
    },
  },
});
